import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgMakeItAFavoriteCard',
})
export default class CmgMakeItAFavoriteCard extends Vue {
  @Prop({ required: true, type: Boolean })
  showFavorites!: boolean;

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get favoritesText(): string {
    return this.countryCode === CountryCode.GB ? 'favourites' : 'favorites';
  }

  get favoriteText(): string {
    return this.countryCode === CountryCode.GB ? 'favourite' : 'favorite';
  }

  get headerText(): string {
    return this.showFavorites ? `Make it a ${this.favoriteText}` : 'No recent orders';
  }

  get imageUrl() {
    return this.showFavorites ? this.$appStore.state.cms.images.icons.heartEmpty.default : '';
  }
}
